import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "../../UI/Modal";
import Loader from "../../UI/Loader";
import Alert from "../../UI/Alert";
import {
  closeFormModal,
  openViewModal,
} from "../../../store/reducers/preguntasConfirmacion/question-confirmation-page/Preguntasconfirmacionplantel.reducer";
import { getPreguntaConfirmacionPlantelByIdThunk, getPreguntasConfirmacionPlantelThunk, updatePreguntaConfirmacionPlantelThunk } from "../../../store/reducers/preguntasConfirmacion/question-confirmation-page/Preguntasconfirmacionplantel.thunks";


const PreguntaConfirmacionFormModalPlantel = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();

  const {
    formModalOpen,
    selectedPregunta,
    formLoading,
    formError,
    page,
    search,
  } = useSelector((state) => state.preguntasConfirmacionPlantel);

  const [formData, setFormData] = useState({ pregunta: "" });

  useEffect(() => {
    if (selectedPregunta) {
      setFormData({ pregunta: selectedPregunta.pregunta || "" });
    }
  }, [selectedPregunta, formModalOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await dispatch(
      updatePreguntaConfirmacionPlantelThunk({
        id: selectedPregunta.id,
        payload: formData,
      }),
    );

    if (result.meta.requestStatus === "fulfilled") {
      dispatch(
        getPreguntasConfirmacionPlantelThunk({ plantelId, page, search }),
      );
      toast.success("Pregunta actualizada exitosamente");
      await dispatch(
        getPreguntaConfirmacionPlantelByIdThunk(selectedPregunta.id),
      );
      dispatch(openViewModal());
    }
  };

  return (
    <Modal
      open={formModalOpen}
      onClose={() => dispatch(closeFormModal())}
      title="Editar pregunta"
      size="lg"
    >
      {formLoading ? (
        <Loader center type="dots" text="Actualizando pregunta..." />
      ) : (
        <form onSubmit={handleSubmit}>
          {formError && <Alert message={formError} variant="error" />}

          <div className="mb-3">
            <label className="form-label fw-medium">
              Pregunta <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              name="pregunta"
              value={formData.pregunta}
              onChange={handleChange}
              placeholder="Ingrese la pregunta"
              rows="4"
              required
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => dispatch(closeFormModal())}
            >
              Cancelar
            </button>

            <button type="submit" className="btn btn-primary">
              Guardar cambios
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default PreguntaConfirmacionFormModalPlantel;
